import React, {useContext, useEffect, useState} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Layout from "components/sales/layout/layout";

const RequestExternal = ({
                         walletListing,
                         listing = []
                     }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await walletListing(1, 'PARTNER')
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Wallet Type',
        'Partner Name',
        'Amount',
        'Approved amount pending for addition',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await walletListing(val.selected + 1, 'PARTNER');
        setIsLoading(false);
    };

    useEffect(() => {
        if (listing && listing?.data !== undefined &&
            listing?.data?.resultSets !== undefined && listing?.data?.resultSets.length > 0) {
            const tableData = ['id', 'wallet_type', 'partner_name', 'balance', 'left_amount'];
            const data = listing?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {Action :
                            // parseInt(JSON.parse(window.localStorage.roles)[0]?.id) === 49 ?
                            // [
                            //     {name:'Transaction Request', link:`wallet/approval/${element['partner_id']}`},
                            // ]
                            // :
                            [
                                {name:'Request List', link:`all-wallet-request-list/${element['partner_id']}`},
                            ]

                    }
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(listing?.data.total / listing?.data.per_page));
        }
    }, [listing])

    return (
        <>
            <Layout
                title={localization.wallet}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={listing?.data && listing?.data?.resultSets}
                    srNo={listing?.from}
                />
            </Layout>
        </>
    )
}

export default RequestExternal

